import { ComponentProps } from 'react';
import { GlobalHeader } from 'br2s-ui-componentlibrary_r2_02';
import { LocalStorageService } from 'br2s-ui-common-utils-02';
import { AUTH_SCOPES } from '@/utilities/authScopes';
import { RootState } from '@/redux/store';
import { renderButtons } from '@/utilities/utilities';

type DropdownButtonsType = ComponentProps<
  typeof GlobalHeader
>['dropdownButtons'];

type HeaderKey =
  | 'TRANSACTIONS'
  | 'CORPORATE_SERVICE_PROVIDER'
  | 'MY_CLIENTS'
  | 'PAYMENT_HISTORY';

export const getHeaderDropdownButtons = ({
  hasProfileAccess,
  hasCspProfile,
}: RootState['auth']): DropdownButtonsType => {
  const { scopes, origin, cspIndicator } = LocalStorageService.getAuthInfo(
    'scopes',
    'origin',
    'cspIndicator',
  );

  const headerDropdownButtons = [
    'DASHBOARD',
    'PAYMENT_SETTINGS',
    'INBOX',
  ] as DropdownButtonsType;

  if (origin === 'CP') headerDropdownButtons?.push('ENTITIES');

  if (scopes?.includes(AUTH_SCOPES.SWITCHPROFILE_READ))
    headerDropdownButtons?.push('SWITCH_PROFILE');

  if (hasProfileAccess) headerDropdownButtons?.push('MY_PROFILE');

  renderButtons(origin ?? '', cspIndicator ?? '', hasCspProfile).forEach(
    ({ headerKey }) => headerDropdownButtons?.push(headerKey as HeaderKey),
  );

  return headerDropdownButtons;
};
